<template>
  <v-app>
    <v-app-bar app>
      <v-spacer />
      <v-btn @click="toggleLocale"
        >{{ $t("language") }} ({{ $i18n.locale }})</v-btn
      >
    </v-app-bar>
    <v-main>
      <v-container v-if="localUuid && tyreInfo">
        <v-row>
          <v-col cols="12" md="6" class="mx-auto">
            <h2>{{ $t("tyreInfo") }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="mx-auto">
            <h2>{{ $t("modelSizeIs") }}</h2>
            <h2>{{ tyreInfo.tireSize }}</h2>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="6" class="mx-auto">
            <div
              class="tyre-brand py-2"
              style="font-size: 24px; font-weight: bold; color: #333333"
            >
              MICHELIN
            </div>
            <div
              class="tyre-model py-1"
              style="font-size: 24px; color: #666666"
            >
              {{ tyreInfo.tireline }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="mx-auto">
            <v-row>
              <v-col cols="6" class="d-flex flex-column">
                <span class="info-label">{{ $t("width") }}</span>
                <span class="info-value">{{ tyreInfo.width }}</span>
              </v-col>
              <v-col cols="6" class="d-flex flex-column">
                <span class="info-label">{{ $t("ratio") }}</span>
                <span class="info-value">{{
                  tyreInfo.dimBox.split("/")[1].slice(0, 2)
                }}</span>
              </v-col>
              <v-col cols="6" class="d-flex flex-column">
                <span class="info-label">{{ $t("diameter") }}</span>
                <span class="info-value">{{
                  tyreInfo.dimBox.split("R")[1].slice(0, 2)
                }}</span>
              </v-col>
              <v-col cols="6" class="d-flex flex-column">
                <span class="info-label">{{ $t("loadIndex") }}</span>
                <span class="info-value">{{ tyreInfo.loadIndex }}</span>
              </v-col>
              <v-col cols="6" class="d-flex flex-column">
                <span class="info-label">{{ $t("speedIndex") }}</span>
                <span class="info-value">{{ tyreInfo.speedIndex }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" class="mx-auto">
            <v-btn
              block
              color="success"
              class="mb-4 custom-btn"
              @click="register"
              :disabled="tyreInfo.isRegister"
            >
              <span class="button-text">
                {{
                  tyreInfo.isRegister
                    ? $t("tyreAlreadyRegistered")
                    : $t("register")
                }}
              </span>
            </v-btn>
            <v-btn block color="info" class="mb-4 custom-btn" @click="moreInfo">
              <span class="button-text">
                {{ $t("moreInfo") }}
              </span>
            </v-btn>
            <v-btn
              block
              color="info"
              class="mb-4 custom-btn"
              @click="termsAndConditions"
            >
              <span class="button-text">
                {{ $t("termsAndConditions") }}
              </span>
            </v-btn>
            <v-btn block color="info" class="mb-4 custom-btn" @click="whyBuy">
              <span class="button-text">
                {{ $t("whyBuy") }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="showDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t("error") }}</v-card-title>
          <v-card-text>{{ $t("noTyreRecord") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="$router.push('/')">{{
              $t("ok")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showImageDialog" max-width="70%">
        <v-card>
          <v-card-text>
            <v-img :src="imageUrl"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="showImageDialog = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="pdfDialog" max-width="90%">
        <v-card>
          <v-card-title class="headline">{{
            $t("termsAndConditions")
          }}</v-card-title>
          <v-card-text>
            <div style="height: 500px; overflow: auto">
              <pdf
                v-if="pdfUrl"
                :src="pdfUrl"
                style="width: 100%; height: 100%"
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="pdfDialog = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import Pdf from "pdf-vue3";

export default {
  components: { Pdf },
  data() {
    return {
      showDialog: false,
      tyreInfo: null,
      localUuid: null,
      isLoading: false,
      valid: true,
      showImageDialog: false,
      imageUrl: "",
      pdfDialog: false,
      pdfUrl: "",
    };
  },
  methods: {
    toggleLocale() {
      this.$i18n.locale = this.$i18n.locale === "en" ? "zh" : "en";
    },
    showNoUuidPopup() {
      console.log("Showing no UUID popup");
      this.showDialog = true;
    },
    async fetchTyreInfo() {
      try {
        console.log("Fetching tyre info for UUID:", this.localUuid);
        const response = await axios.get(
          `https://tyremanagementwebhost20240620094429.azurewebsites.net/api/services/app/Configuration/GetTyreInfo?uuid=${this.localUuid}`
        );
        this.tyreInfo = response.data.result;
        console.log("Tyre Info:", this.tyreInfo);
      } catch (error) {
        console.error("Error fetching tyre info:", error);
        alert(this.$t("errorFetchingTyreInfo"));
      }
    },
    moreInfo() {
      const tyreline = this.tyreInfo.tireline.replace(/ /g, "-");
      const url = `https://www.michelin.com.hk/${this.$i18n.locale}/auto/tyres/michelin-${tyreline}`;
      window.open(url, "_blank");
    },
    register() {
      this.$router.push({
        name: "VehicleWarranty",
        params: { uuid: this.localUuid },
      });
    },
    termsAndConditions() {
      this.pdfUrl = `https://hocan.blob.core.windows.net/tyre-registration-attachments/warranty_${this.$i18n.locale}.pdf`;
      this.pdfDialog = true;
    },
    whyBuy() {
      this.imageUrl =
        "https://hocan.blob.core.windows.net/tyre-registration-attachments/poster 2 low res.jpg";
      this.showImageDialog = true;
    },
  },
  created() {
    console.log("Component created");
    console.log("Route params:", this.$route.params);
    this.localUuid = this.$route.params.uuid;
    console.log("Local UUID:", this.localUuid);

    if (this.localUuid) {
      this.fetchTyreInfo();
    } else {
      this.showNoUuidPopup();
    }
  },
};
</script>

<style scoped>
.info-label {
  font-size: 14px;
  color: #666666;
}
.info-value {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.custom-btn {
  padding: 12px 16px !important;
  height: auto !important;
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.button-text {
  font-size: 18px;
  text-align: center;
  display: block;
  width: 100%;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  line-height: 1.4 !important;
}

@media (max-width: 600px) {
  .button-text {
    font-size: 18px;
  }
}

@media (max-width: 400px) {
  .button-text {
    font-size: 18px;
  }
}
</style>
